module.exports = __webpack_public_path__ + "static/media/image_one.947b882b.png";